import { apiFields } from "./_utils";
import { getSignatures } from "js/api/signatureApi";
import _ from "lodash";

export const createSignatureStore = (set, get, api, setIn) => ({
	...apiFields(),
	data: {
		signatures: [],
		appControls: [],
	},
	signaturesMap: {},
	nativeAppControlsMap: {},

	fetch: async () => {
		setIn({ isFetching: true });
		const data = await getSignatures();
		const nativeAppControlsMap = _.keyBy(data.appControls, "id");
		const signaturesMap = _.keyBy(data.signatures, "id");
		setIn({ data, signaturesMap, nativeAppControlsMap, isFetching: false, lastFetched: Date.now() });
	},
});

/**
 * @param {ClasswizeState} state
 * @returns {IGetSignatureDbReturn}
 */
export const getSignatureDb = (state) => {
	return {
		signatures: state.signatures.data.signatures,
		signaturesMap: state.signatures.signaturesMap,
		lookup: function (id) {
			const res = this.signatures.find((i) => i.id === id);
			return res ? res.name : id;
		},
		favicon: function (id) {
			const signature = this.signatures.find((i) => i.id === id);
			if (signature) {
				if (signature.favicon_url !== undefined) {
					return signature.favicon_url;
				} else {
					return "https://" + signature.url + "/favicon.ico";
				}
			}
			return "https://" + id + "/favicon.ico";
		},
		find: function (id) {
			return this.signaturesMap[id];
		},
	};
};

/**
 * @param {ClasswizeState} state
 * @returns {IGetNativeAppControlsDbReturn}
 */
export const getNativeAppControlsDb = (state) => {
	return {
		nativeAppControls: state.signatures.data.appControls,
		nativeAppControlsMap: state.signatures.nativeAppControlsMap,
		find: function (id) {
			return this.nativeAppControlsMap[id];
		},
	};
};
